import "core-js/modules/es6.regexp.split.js";
import "core-js/modules/es6.function.name.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.array.from.js";
import "core-js/modules/es6.string.iterator.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es7.array.includes.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  props: {
    attachments: {
      type: Array,
      required: true
    },
    readonly: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    icon: function icon(attachment) {
      var extension = attachment.extension || attachment.name.split('.')[1];

      switch (extension) {
        case 'txt':
          return 'far:file';

        case 'odt':
          return 'far:file-doc';

        case 'xls':
        case 'xlsx':
          return 'far:file-xls';

        case 'doc':
        case 'docx':
          return 'far:file-word';

        case 'jpg':
        case 'jpeg':
        case 'png':
        case 'gif':
        case 'svg':
        case 'bmp':
          return 'far:file-image';

        default:
          return 'far:file';
      }
    },
    sizeMb: function sizeMb(attachment) {
      var sizeInMB = attachment.attachment_id ? (attachment.size_in_bytes / 1048576).toFixed(2) + 'MB' : (attachment.size / 1048576).toFixed(2) + 'MB';
      return sizeInMB;
    },
    updateAttachments: function updateAttachments(data) {
      var _this = this;

      var validExtensions = ['doc', 'docx', 'pdf', 'png', 'jpg', 'jpeg', 'xls', 'xlsx', 'odt', 'txt'];
      var validImages = ['png', 'jpg', 'jpeg'];
      var excluded = false;
      var message;
      Array.from(data.target.files).forEach(function (file) {
        if (validExtensions.includes(file.name.split('.')[1])) {
          if (validImages.includes(file.name.split('.')[1])) {
            if (file.size > 52428800) {
              message = 'Immage max size is of 50MB';
              excluded = true;
              return;
            }
          } else {
            if (file.size > 3145728) {
              message = 'File max size is of 3MB';
              excluded = true;
              return;
            }
          }
        } else {
          message = 'One or more files not supported';
          excluded = true;
          return;
        }

        _this.attachments.push(file);
      });

      if (excluded) {
        this.$q.notify({
          message: message,
          type: 'negative'
        });
      }
    },
    removeAttachment: function removeAttachment(attachment, index) {
      var _this2 = this;

      try {
        this.showLoading();
        attachment.index = index;

        if (!attachment.attachment_id) {
          this.$emit('delete-local-attachment', attachment);
          this.$q.notify({
            message: 'Attachment removed ',
            type: 'positive'
          });
          this.hideLoading();
          return;
        }

        this.$axios.delete('/attachments/' + attachment.attachment_id).then(function (response) {
          _this2.$emit('delete-local-attachment', attachment);

          _this2.$q.notify({
            message: 'Attachment removed ',
            type: 'positive'
          });
        });
      } catch (error) {
        this.$q.notify({
          message: 'Error while deleting',
          type: 'negative'
        });
      } finally {
        this.hideLoading();
      }
    },
    downloadAttachment: function downloadAttachment(attachment) {
      try {
        this.showLoading();
        this.$axios.get('/attachments/' + attachment.attachment_id + '/download', attachment).then(function (response) {
          window.open(response.data, '_blank');
        });
      } catch (error) {
        this.$q.notify({
          message: 'Error while downloading',
          type: 'negative '
        });
      } finally {
        this.hideLoading();
      }
    }
  }
};